<template>
  <div>
    <suspense>
      <TermsOfUse
        :lang="lang"
        :eulafile-identifier="eulafileIdentifier"
        :terms-text="termsText"
        :cookie-policy="cookiePolicy"
        :terms-of-use-url="termsOfUseUrl"
        @approval-status-changed="approvalStatusChanged"
        @on-terms-error="showTermsError"
      />
    </suspense>
    <IgcButton
      class="confirm-btn"
      :disabled="!enableConfirmButton"
      @click="onClose"
    >
      {{ continueButton }}
    </IgcButton>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { defineAsyncComponent, ref } from 'vue';

const TermsOfUse = defineAsyncComponent(() => import('../TermsOfUse/TermsOfUse.vue'));
const IgcButton = defineAsyncComponent(() => import('../IgcButton/IgcButton.vue'));

defineProps({
  termsText: {
    type: String as PropType<string>,
    required: true,
  },

  cookiePolicy: {
    type: String as PropType<string>,
    required: true,
  },

  termsOfUseUrl: {
    type: String as PropType<string>,
    required: true,
  },

  lang: {
    type: String as PropType<string>,
    required: true,
  },

  eulafileIdentifier: {
    type: String as PropType<string>,
    required: true,
  },

  continueButton: {
    type: String as PropType<string>,
    required: true,
  },
});

const enableConfirmButton = ref(false);
const emits = defineEmits(['on-close', 'show-terms-error']);

function approvalStatusChanged(isApproved: boolean) {
  enableConfirmButton.value = isApproved;
}
function onClose() {
  emits('on-close');
}

function showTermsError() {
  emits('show-terms-error');
}
</script>

<style lang="less" scoped>
.confirm-btn {
  margin-top:   28px;
  margin-left:  auto;
  margin-right: auto;

  ::v-deep(button) {
    border-radius: 25px;
    padding-left:  30px;
    padding-right: 30px;
    font-size:     12px;
    line-height:   18px;
    width:         100%;
  }
}
</style>
